module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/96edc964e2954ef3166a77f87a6cc045.png";